<app-toast />
@if (showNav()) {
  <app-nav />
}
<router-outlet />
